<template lang="pug">
.usage-fees-only-payment-rate-table
  .d-flex.flex-row.align-items-center.mb-2
    .title.mr-1 居住費（月額）
    span.validation-label 必須
  b-table-simple.dark-boder-table.waiter-judge-template-table
    b-thead
      b-tr
        b-th
        b-th 自立
        b-th 1割負担
        b-th 2割負担
        b-th 3割負担
    b-tbody
      UsageFeesOnlyPaymentRateTableRow(v-if="showRomType('multiBed')" v-model="_value.multiBed" roomId="multiBed" roomName="従来型多床室")
      UsageFeesOnlyPaymentRateTableRow(v-if="showRomType('conventinalSingle')" v-model="_value.conventinalSingle" roomId="conventinalSingle" roomName="従来型個室")
      UsageFeesOnlyPaymentRateTableRow(v-if="showRomType('unitTypeSingle')" v-model="_value.unitTypeSingle" roomId="unitTypeSingle" roomName="ユニット型個室")
      UsageFeesOnlyPaymentRateTableRow(v-if="showRomType('double')" v-model="_value.double" roomId="double" roomName="２人部屋（夫婦部屋）")
      UsageFeesOnlyPaymentRateTableRow(v-if="showRomType('single')" v-model="_value.single" roomId="single" roomName="個室")

      UsageFeesOnlyPaymentRateTableRow(v-for="(customRoom, index) in _value.customRecruitmentRoom" v-model="_value.customRecruitmentRoom[index]"
        :roomId="customRoom.id" :roomName="customRoom.roomName")

  .errors(v-for="fieldName in _fieldNames")
    .error-messages(v-for="error in errors.collect(fieldName)")
      .error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { UsageFeesOnlyPaymentRate } from "@/commons/services/WaiterRecruitments";
import { FacilityGetModel } from "@/commons/services/Facilities";

import UsageFeesOnlyPaymentRateTableRow from "@/pc/containers/waiters/UsageFeesOnlyPaymentRateTableRow.vue";

/**
 * ### 料金シミュレーション(自立・負担割合変動タイプ) 部屋料金コンポーネント
 */
@Component({
  components: {
    UsageFeesOnlyPaymentRateTableRow
  }
})
export default class UsageFeesOnlyPaymentRateTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: UsageFeesOnlyPaymentRate;

  @Prop()
  facility!: FacilityGetModel;

  get _value(): UsageFeesOnlyPaymentRate {
    return this.value;
  }

  set _value(newValue: UsageFeesOnlyPaymentRate) {
    this.$emit("input", newValue);
    return;
  }

  get _fieldNames(): string[] {
    let fieldNames: string[] = [];
    fieldNames = fieldNames.concat(this.createFieldNames("multiBed"));
    fieldNames = fieldNames.concat(this.createFieldNames("conventinalSingle"));
    fieldNames = fieldNames.concat(this.createFieldNames("unitTypeSingle"));
    fieldNames = fieldNames.concat(this.createFieldNames("single"));
    fieldNames = fieldNames.concat(this.createFieldNames("double"));

    return fieldNames;
  }

  public createFieldNames(roomName: string): string[] {
    return [
      `usage-fees-only-payment-rate-${roomName}-no-need-nursing-care-none`,
      `usage-fees-only-payment-rate-${roomName}-need-nursing-care-percent-10`,
      `usage-fees-only-payment-rate-${roomName}-need-nursing-care-percent-20`,
      `usage-fees-only-payment-rate-${roomName}-need-nursing-care-percent-30`
    ];
  }

  /**
   * ### 施設が表示対象にしている部屋種類か否かを返す
   */
  public showRomType(roomTypeName: string): boolean {
    switch (roomTypeName) {
      case "multiBed": {
        return this.facility.recruitmentRoom.multiBed;
      }
      case "conventinalSingle": {
        return this.facility.recruitmentRoom.conventinalSingle;
      }
      case "unitTypeSingle": {
        return this.facility.recruitmentRoom.unitTypeSingle;
      }
      case "double": {
        return this.facility.recruitmentRoom.double;
      }
      case "single": {
        return this.facility.recruitmentRoom.single;
      }
      default: {
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-only-payment-rate-table {
  .table-name {
    font-size: 18px;
    font-weight: bold;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
}
</style>
